export const reportCalendarAbuseLink = "eF0sLd";
export default {reportCalendarAbuseLink};